import { Alert, Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useState } from "react";
import { renderClose, SimpleDialog } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propFileField } from "../../common/entityStoreForm";
import { propRequired } from "../../common/entityStoreValidators";
import { SaveButton } from "../../common/SaveButton";

export const SaleArticleDetailsImportDialog = (props: {
    close: () => void;
    onChange(): void;
    simpleDialog: SimpleDialog;
}) => {
    const [useStore] = useState(() => createEntityStore<ImportParams>({
        data: { file: null },
        path: "articles/inventoryArticles/saleArticleDetailsImport",
        id: null,
        onSaved() {
            props.onChange();
            props.close();
        },
        propValidators: [
            propRequired("file"),
        ]
    }));

    function showInfo() {
        props.simpleDialog.show("Format info", <Alert severity="info">
            File format should be CSV file without header in win1250/win1257 encoding based on country, with semicolon as a separator and the following columns:
            <ul>
                <li>Sales article code</li>
                <li>Project code</li>
                <li>Price</li>
                <li>Use quantity discount (1 or 0)</li>
                <li>Package sales article code</li>
                <li>Package quantity</li>
                <li>Categories (";" is category sepearator, "$" is nested category separator)</li>
                <li>Article name</li>
                <li>Is only for auto (1 or 0)</li>
                <li>Package type (Small package/Package/Gift or empty)</li>
            </ul>
        </Alert>);
    }

    const { save, isSaveDisabled } = useStore(p => ({ save: p.save, isSaveDisabled: p.isSaveDisabled }));
    return <>
        <DialogTitle>Sales article details import</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2}>
                <Grid item xs={12}>{propFileField(useStore)("file", "CSV file")}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={showInfo} variant="outlined">Import info</Button>
            <SaveButton save={save} disabled={isSaveDisabled} text="Import" />
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};

interface ImportParams {
    file: File | null;
}
